import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import ActionButton from "./ActionButton";

const DeleteTenantRolesModal = ({ open, onClose, onConfirm, task }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Tenant Role</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete the tenant role{" "}
          <strong>{task?.title}</strong>? This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <ActionButton onClick={onClose} tone="ghost">
          Cancel
        </ActionButton>
        
        <ActionButton onClick={onConfirm} tone="danger">
          Delete
        </ActionButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteTenantRolesModal;
